import { selfCheckInRoute } from 'src/apis';

export const productsApiRoute = `${selfCheckInRoute}/products/insurances-extras`; // TODO: CHANGE ROUTE
